<app-home-it *ngIf="global.culture == 'it'"></app-home-it>
<app-home-en *ngIf="global.culture == 'en'"></app-home-en>
<app-home-es *ngIf="global.culture == 'es'"></app-home-es>
<app-home-fr *ngIf="global.culture == 'fr'"></app-home-fr>
<app-contact></app-contact>
